import React, { useState, useEffect } from 'react';
import { Fingerprint, Shield, Activity, BarChart3, Zap, TrendingUp } from 'lucide-react';

/**
 * ProcessingCard for showing "Engine" progress after a vote is cast.
 */
export const ProcessingCard = () => {
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setProgress(old => (old >= 100 ? 100 : old + 5));
        }, 100);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="bg-white dark:bg-gray-800 rounded-[40px] h-[550px] flex flex-col items-center justify-center p-12 text-center shadow-2xl relative overflow-hidden group border border-gray-100 dark:border-gray-700 animate-in zoom-in-95 duration-300">
            <div className="absolute top-0 left-0 w-full h-2 bg-gray-50">
                <div
                    className={`h-full bg-primary-600 transition-all duration-300 shadow-lg shadow-purple-500/50`} style={{ width: `${progress}%` }}></div>
            </div>
            <div className="text-5xl font-black italic text-primary-600 tracking-tighter animate-pulse mb-8 uppercase">Updating Engine...</div>
            <div className="text-[120px] font-black text-gray-900 dark:text-white leading-none tracking-tighter tabular-nums drop-shadow-2xl">{progress}%</div>
            <div className="mt-8 flex gap-8">
                {['Sending Vote', 'Syncing Data', 'Finalizing Result'].map((label, i) => (
                    <div key={i} className="flex flex-col items-center gap-3">
                        <div className={`w-3 h-3 rounded-full transition-all duration-500 ${progress > (i * 33) ? 'bg-primary-600 shadow-[0_0_15px_rgba(124,58,237,0.8)] scale-125' : 'bg-gray-200 dark:bg-gray-700'}`} />
                        <span className="text-2xs font-black uppercase tracking-[0.2em] text-gray-500 dark:text-gray-500">{label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
